import { createFileRoute, redirect } from '@tanstack/react-router';
import { StoreRegion } from '~/graphql/graphql.gen';
import { SaleType } from '~/stores/sale';

export const Route = createFileRoute('/_auth/_main-navigation/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/ventes',
      search: {
        region: StoreRegion.Fr,
        type: SaleType.Ongoing,
      },
    });
  },
});
